module.exports = __webpack_public_path__ + "static/media/grapes.a3ea51ea.svg";